import { render, staticRenderFns } from "./goods-comment.vue?vue&type=template&id=29ab8ad6&scoped=true&"
import script from "./goods-comment.vue?vue&type=script&lang=js&"
export * from "./goods-comment.vue?vue&type=script&lang=js&"
import style0 from "./goods-comment.vue?vue&type=style&index=0&id=29ab8ad6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ab8ad6",
  null
  
)

export default component.exports